module.exports = "<template>\n\n    <h1>${'page_not_found' | t}</h1>\n\n</template>\n";